const CandidateApprovalStatusEnum = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export default CandidateApprovalStatusEnum;
